<template>
  <div class="nav-md purchase-orders-summary full-height" :class="{
      toggled: isToggled
  }">
    <div class="container body full-height">
      <div class="main_container" v-if="userIsLogged">
        <zee-sidebar-menu></zee-sidebar-menu>
        <zee-topbar-menu></zee-topbar-menu>
        <div class="right_col" role="main">
          <router-view></router-view>
          <vue-progress-bar></vue-progress-bar>
        </div>
      </div>
      <div v-else class="full-height">
        <router-view name="login-view"></router-view>
        <router-view name="signup-view"></router-view>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import * as types from "@/store/mutation-types";

export default {
  name: "App",
  computed: {
    ...mapGetters({
      userIsLogged: "userIsLoggedState",
      isMenuToggled: "isMenuToggled",
      isPo: "isPo",
      isPayments: "isPayments",
      isReceivable: "isReceivable"
    }),
    isToggled() {
      return this.isMenuToggled;
    },
    isPo() {
      return this.isPo;
    },
    isPayments() {
      return this.isPayments;
    },
    isReceivable() {
      return this.isReceivable;
    }
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$store.dispatch("setUserInfo");
    if (window.location.hostname.includes("zeenow"))
      this.$store.commit(types.SET_IS_ZEENOW, true);
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.3s;
}

// .fade-enter-active {
//     transition-delay: .3s;
// }

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue